import React, { Component } from 'react';

class PageTitle extends Component {
    render() {
        return (
            <div className="pp-page-title">
                {this.props.pageTitle && <h1 className="pp-heading-1">{ this.props.pageTitle }</h1>}
                {this.props.pageActions && <div className="pp-page-actions">
                    { this.props.pageActions }
                </div>}
            </div>
        );
    }
}

export default PageTitle;



// WEBPACK FOOTER //
// ./src/components/PageTitle.js